import { __assign } from "tslib";
var WEBSTORE_API_BASE_API_CONFIG = {
    baseUrl: '',
    marketLocale: '',
    scopes: [],
    siteContext: "jabra" /* Jabra */,
    storage: localStorage,
};
export var getWebStoreApiConfig = function () {
    return WEBSTORE_API_BASE_API_CONFIG;
};
export var setWebStoreApiConfig = function (config) {
    WEBSTORE_API_BASE_API_CONFIG = __assign({}, config);
};
